<template>
  <div class="min-h-screen bg-white flex">
    <!-- Left Side - Image/Branding (Desktop) -->
    <div class="hidden lg:flex lg:w-1/2 bg-cover bg-center relative" style="background-image: url('https://images.unsplash.com/photo-1556742049-0cfed4f7a07d?w=1200')">
      <div class="absolute inset-0 bg-gradient-to-br from-blue-900/80 to-blue-700/80"></div>
      <div class="relative z-10 flex flex-col justify-between h-full p-12 text-white">
        <div>
          <a href="/" class="flex items-center gap-2.5">
            <div class="w-10 h-10 bg-white rounded-xl flex items-center justify-center">
              <span class="text-blue-600 font-bold text-lg">R</span>
            </div>
            <span class="text-xl font-bold">Fluxreload</span>
          </a>
        </div>
        <div>
          <h1 class="text-4xl font-bold mb-4">Cartes cadeaux et codes de recharge</h1>
          <p class="text-blue-100 text-lg">La meilleure sélection de cartes cadeaux en Afrique de l'Ouest</p>
        </div>
      </div>
    </div>

    <!-- Right Side - Login Form -->
    <div class="flex-1 flex items-center justify-center p-6 md:p-12">
      <div class="w-full max-w-md">
        <!-- Mobile Logo -->
        <div class="lg:hidden text-center mb-8">
          <a href="/" class="inline-flex items-center gap-2.5">
            <div class="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center">
              <span class="text-white font-bold text-lg">R</span>
            </div>
            <span class="text-lg font-bold text-blue-800">Fluxreload</span>
          </a>
        </div>

        <h1 class="text-2xl font-bold text-gray-900 mb-2">Connexion</h1>
        <p class="text-gray-500 mb-8">Bienvenue sur Fluxreload</p>

        <form
          class="space-y-5"
          v-bus:EVENTS.USER.LOGIN.submit.prevent
          v-redirect-on="{
            event: $constants.EVENTS.USER.LOGIN_SUCCESS,
            to: '/profile'
          }"
        >
          <!-- Email -->
          <div class="border border-gray-300 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-blue-600 focus-within:border-blue-600 transition-all">
            <input
              name="email"
              type="email"
              required
              class="w-full px-4 py-3 outline-none transition-all"
              placeholder="Email"
            />
          </div>

          <!-- Password -->
          <div class="border border-gray-300 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-blue-600 focus-within:border-blue-600 transition-all">
            <input
              name="password"
              type="password"
              required
              class="w-full px-4 py-3 outline-none transition-all"
              placeholder="Mot de passe"
            />
          </div>

          <!-- Forgot password -->
          <div class="text-right">
            <button
              type="button"
              class="text-sm text-blue-600 hover:underline"
              @click="$bus.emit($constants.EVENTS.PASSWORD_RESET.REQUESTED)"
            >
              Mot de passe oublié ?
            </button>
          </div>

          <!-- Submit button -->
          <button
            type="submit"
            class="w-full py-3.5 bg-blue-600 text-white font-semibold rounded-xl shadow-md hover:shadow-lg hover:bg-blue-700 transition-all duration-200"
            :disabled="$stores?.user?.state?.loading"
          >
            <span v-if="$stores?.user?.state?.loading">Connexion...</span>
            <span v-else>Se connecter</span>
          </button>
        </form>

        <!-- Divider -->
        <div class="relative my-8">
          <div class="absolute inset-0 flex items-center">
            <div class="w-full border-t border-gray-200"></div>
          </div>
          <div class="relative flex justify-center text-sm">
            <span class="px-4 bg-white text-gray-500">ou continuer avec</span>
          </div>
        </div>

        <!-- Social login buttons -->
        <div class="flex justify-center">
          <button
            type="button"
            class="flex items-center justify-center gap-3 px-6 py-3 border border-gray-300 rounded-xl hover:bg-gray-50 transition-colors w-full"
          >
            <svg class="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            <span class="font-medium text-gray-700">Continuer avec Google</span>
          </button>
        </div>

        <!-- Sign up link -->
        <p class="text-center text-gray-600 mt-8">
          Pas encore de compte ?
          <router-link to="/register" class="text-blue-600 font-semibold hover:underline">S'inscrire</router-link>
        </p>

        <!-- Back to home -->
        <div class="text-center mt-6">
          <a href="/" class="inline-flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
            </svg>
            Retour à l'accueil
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
